import React from 'react'
import style from '../../../models/Block/Styles/index.module.scss'
import { isOdd } from '../../../../utils/math'
import { Collapse } from 'react-bootstrap'
import { blockConstructor } from '../../../models/Block/control'
import { generateAriaId } from '../../utils/generateAriaId'
import { generateUniqueLocalId } from '../../utils/generateUniqueLocalId'
import { useExpand } from '../../../../hooks/useExpand'
import { PATH_JOINER } from '../../../models/utils/getConfigBitPath'
import { DescriptionBtnWithPopup } from '../../../buttons/PromptBtn/DescriptionBtnWithPopup'
import { getLabel } from '../../../../utils/getLabel'

interface Props {
    dataPath: string
    elements?: JSX.Element[]
    title?: string
    className?: string
    data?: any
    dataSchema?: any
    name?: string
    wrapper?: string
    buttons?: JSX.Element[]
    footerData?: JSX.Element[]
    headerControl?: any
    levelDeep?: number
    element_id?: string
}

export const WrappedBlockACTN = ({
    dataPath,
    elements,
    title = '',
    className,
    data,
    dataSchema = {},
    name = '',
    wrapper,
    buttons,
    footerData = [],
    headerControl = [],
    levelDeep = 2,
    element_id,
}: Props) => {
    const {
        is_required: isRequired,
        is_auxiliary: isCollapsed,
        requiredMark,
    } = dataSchema

    const path = [...dataPath.split(PATH_JOINER), name]
    const localId = generateUniqueLocalId({ path, name, element_id })
    const ariaID = generateAriaId()
    const collapseBtnClassName = style.button

    const { expandBtn, expanded, toggle } = useExpand({
        isExpanded: !isCollapsed,
        uniqueID: localId,
        ariaID,
        className: collapseBtnClassName,
    })

    const label = getLabel(name, title)
    const styleHeader = `${style.header} block-header-${levelDeep} block-bg-header-default p-0 rounded-top`
    const styleBody = isOdd(levelDeep) ? 'bg-white' : 'app-bg-primary'

    const block = elements
        ? elements?.map((element: JSX.Element, i: number) => (
              <div key={i}>{element}</div>
          ))
        : blockConstructor({
              dataSchema,
              data,
              dataProp: data,
              name,
              childrenPath: path.join(PATH_JOINER),
              dataPath,
              pathWithElementID: undefined,
              blockState: true,
              builderType: 'actionUiBuilder',
              levelDeep: 1,
              element_id,
              isRuleActive: true,
          })

    const desc = dataSchema.description && (
        <DescriptionBtnWithPopup
            type="small"
            header={label}
            description={dataSchema.description}
            className="ms-auto me-2 text-white"
        />
    )

    return (
        <div
            className={`${className} ${
                !wrapper
                    ? 'width-49'
                    : 'w-100 border-left border-right border-bottom'
            } d-flex flex-column rounded mt-2 mb-2 position-relative border`}
        >
            <div className={styleHeader}>
                <div
                    className="w-100"
                    onClick={toggle}
                >
                    <h4
                        className={`${style.title} ${!title && style.capitalized}`}
                    >
                        {wrapper === 'block_dictionary_card_row' ? (
                            <div style={{ height: '37px' }} />
                        ) : (
                            label
                        )}{' '}
                        {isRequired && requiredMark && <span>*</span>}
                    </h4>
                </div>
                {buttons &&
                    buttons.map((element: JSX.Element, index: number) => (
                        <span
                            key={index}
                            className="d-flex"
                        >
                            {element}
                        </span>
                    ))}
                {desc}
                {!!headerControl &&
                    headerControl.map((el: JSX.Element, i: number) => (
                        <span key={i}>{el}</span>
                    ))}
                {expandBtn}
            </div>
            <Collapse in={expanded}>
                <div className="p-relative">
                    <div
                        className={`p-2 ${styleBody} rounded-bottom`}
                        id={ariaID}
                    >
                        {block}
                    </div>
                    {footerData.length > 0 && (
                        <div
                            style={{ background: '#C5DBEA' }}
                            className="d-flex justify-content-end p-1"
                        >
                            {footerData.map((el: JSX.Element, i: number) => (
                                <div key={i}>{el}</div>
                            ))}
                            {expandBtn}
                        </div>
                    )}
                </div>
            </Collapse>
        </div>
    )
}
